<template>
	<div class="cont">
		<!-- 历史数据 -->
		<div class="historyTable">
			<div class="topBlock">
				<div class="blockTitle">历史数据</div>
				<div>
					<el-date-picker
					v-model="yearValue"
					type="year"
					value-format="yyyy"
					:picker-options="timeCycle"
					@change="getYearData">
				</el-date-picker></div>
			</div>

			<div class="tableBlock">
				<div class="notableData" v-if="tableData.length == 0">暂无数据</div>
				<el-table :data="tableData" class="tableStyle" v-loading="tableLoading"  style="width: 100%;" 
            :header-cell-style="{'background': '#F7F7FF','text-align': 'left','line-height': 'initial','overflow': 'auto',
            'font-size': '14px','font-weight': 400,'color': '#333333','font-weight':'bold','border-radius': '8px 8px 0px 0px'}"
						>
                <el-table-column label="时间" width="100px">
									<template slot-scope="scope">
										{{ scope.row.year +'年'+scope.row.month }}月
									</template>
								</el-table-column>
                <el-table-column prop="newMemberBuyNum" label="当月新会员购买客户数" width="180px"></el-table-column>
                <el-table-column prop="newMemberNum" label="当月新会员数" width="140px"></el-table-column>
                <el-table-column prop="newMemberFirstBuyRate" label="新会员首购率" width="140px">
									<template slot-scope="scope">
										{{ scope.row.newMemberFirstBuyRate}}%
									</template>
								</el-table-column>
                <el-table-column prop="firstBuySchedule" label="首购目标完成进度"  width="140px">
									<template slot-scope="scope">
										{{ scope.row.firstBuySchedule}}%
									</template>
								</el-table-column>

                <el-table-column prop="purchasedMemberNum" label="已购会员数"  width="140px"></el-table-column>
                <el-table-column prop="buyerNum" label="成交客户数"  width="140px"></el-table-column>
								<el-table-column prop="purchasedMemberBuyRate" label="已购会员占比"  width="140px">
									<template slot-scope="scope">
										{{ scope.row.purchasedMemberBuyRate}}%
									</template>
								</el-table-column>
								<el-table-column prop="oldSchedule" label="招募目标完成进度"  width="140px">
									<template slot-scope="scope">
										{{ scope.row.oldSchedule}}%
									</template>
								</el-table-column>

								<el-table-column prop="purchasedMember90Num" label="近90天复购客户数"  width="140px"></el-table-column>
								<el-table-column prop="buyer90Num" label="近90天成交客户数"  width="140px"></el-table-column>
								<el-table-column prop="purchased90Rate" label="近90天复购率"  width="140px">
									<template slot-scope="scope">
										{{ scope.row.purchased90Rate}}%
									</template>
								</el-table-column>
								<el-table-column prop="purSchedule" label="复购目标完成进度"  width="140px">
									<template slot-scope="scope">
										{{ scope.row.purSchedule}}%
									</template>
								</el-table-column>

								<el-table-column prop="lossNum" label="流失客户数"  width="140px"></el-table-column>
								<el-table-column prop="buyerNum" label="历史成交总客户数"  width="140px"></el-table-column>
								<el-table-column prop="lossRate" label="流失客户占比"  width="140px">
									<template slot-scope="scope">
										{{ scope.row.lossRate}}%
									</template>
								</el-table-column>
								<el-table-column prop="lossSchedule" label="流失目标完成进度"  width="140px">
									<template slot-scope="scope">
										{{ scope.row.lossSchedule}}%
									</template>
								</el-table-column>
            </el-table>
			</div>

		</div>
		<!-- 历史趋势 -->
		<div>
			<span class="blockTitle">历史趋势</span>
			<div>
				<el-form ref="formData" :model="formData" class="formData">
					<el-form-item class="formItem">
						<div class="formLabel" slot="label">
							首购转化
						</div>
						<el-checkbox-group v-model="formData.type" class="formCheck" @change="handleCheckedForm" :max="4">
							<el-checkbox label="当月新会员购买客户数" name="type"></el-checkbox>
							<el-checkbox label="当月新会员数" name="type"></el-checkbox>
							<el-checkbox label="新会员首购率" name="type"></el-checkbox>
							<el-checkbox label="首购目标完成进度" name="type"></el-checkbox>
						</el-checkbox-group>
					</el-form-item>

					<el-form-item class="formItem">
						<div class="formLabel" slot="label">
							老客招募
						</div>
						<el-checkbox-group v-model="formData.type" class="formCheck" @change="handleCheckedForm" :max="4">
							<el-checkbox label="已购会员数" name="type"></el-checkbox>
							<el-checkbox label="成交客户数" name="type"></el-checkbox>
							<el-checkbox label="已购会员占比" name="type"></el-checkbox>
							<el-checkbox label="招募目标完成进度" name="type"></el-checkbox>
						</el-checkbox-group>
					</el-form-item>

					<el-form-item class="formItem">
						<div class="formLabel" slot="label">
							复购召回
						</div>
						<el-checkbox-group v-model="formData.type" class="formCheck" @change="handleCheckedForm" :max="4">
							<el-checkbox label="近90天复购客户数" name="type"></el-checkbox>
							<el-checkbox label="近90天成交客户数" name="type"></el-checkbox>
							<el-checkbox label="近90天复购率" name="type"></el-checkbox>
							<el-checkbox label="复购目标完成进度" name="type"></el-checkbox>
						</el-checkbox-group>
					</el-form-item>

					<el-form-item class="formItem">
						<div class="formLabel" slot="label">
							流失激活
						</div>
						<el-checkbox-group v-model="formData.type" class="formCheck" @change="handleCheckedForm" :max="4">
							<el-checkbox label="流失客户数" name="type"></el-checkbox>
							<el-checkbox label="历史成交客户数" name="type"></el-checkbox>
							<el-checkbox label="流失客户占比" name="type"></el-checkbox>
							<el-checkbox label="流失目标完成进度" name="type"></el-checkbox>
						</el-checkbox-group>
					</el-form-item>
				</el-form>
				<div class="formNum">已选：<span style="color:#6461E7">{{echartsData.legendDatas.length}}</span>/4项</div>
			</div>
			<div style="position: relative;width: 1200px;height:600px;background: #FFFFFF;" v-loading="tableLoading">
				<div class="noData" v-show="echartsData.legendDatas.length === 0 || tableData.length === 0"> 暂无数据</div>
				<div class="echart-box" style="position: relative;" v-show="echartsData.legendDatas.length !== 0 && tableData.length !== 0">
					<div id="line-chart" style="width: 1200px;height:600px;"></div>
				</div>
			</div>
		</div>
	</div>
</template>
	
<script>
import echarts from "echarts";
import {
	historyData
} from "@/api/industry/strategy.js";
export default {
name: '' ,
components: {},
props:{},
data() {
	return {
		yearValue:new Date(Date.now()).getFullYear().toString(),
		tableLoading:false,
		tableData:[],
		formData:{
			type: ['新会员首购率','已购会员占比','近90天复购率','流失客户占比'],
		},
		echartsData:{
			legendDatas:['新会员首购率','已购会员占比','近90天复购率','流失客户占比'],
		},
		options:'',
		listChartsData:[
				{
						name: '当月新会员购买客户数',
						type: 'line',
						itemStyle: {
                normal: {
                    lineStyle: {
                      width:1// 0.1的线条是非常细的了
                    }
                }
            },
						smooth: true,
						data: [],
				},
				{
						name: '当月新会员数',
						type: 'line',
						itemStyle: {
                normal: {
                    lineStyle: {
                      width:1
                    }
                }
            },
						smooth: true,
						data: [],  
				},
				{
						name: '新会员首购率',
						type: 'line',
						itemStyle: {
                normal: {
                    lineStyle: {
                      width:1
                    }
                }
            },
						smooth: true,
						data: [],
				},
				{
						name: '首购目标完成进度',
						type: 'line',
						itemStyle: {
                normal: {
                    lineStyle: {
                      width:1
                    }
                }
            },
						smooth: true,
						data: [],
				},
				{
						name: '已购会员数',
						type: 'line',
						itemStyle: {
                normal: {
                    lineStyle: {
                      width:1
                    }
                }
            },
						smooth: true,
						data: [],
				},
				{
						name: '成交客户数',
						type: 'line',
						itemStyle: {
                normal: {
                    lineStyle: {
                      width:1
                    }
                }
            },
						smooth: true,
						data: [],   
				},
				{
						name: '已购会员占比',
						type: 'line',
						itemStyle: {
                normal: {
                    lineStyle: {
                      width:1
                    }
                }
            },
						smooth: true,
						data: [],
				},
				{
						name: '招募目标完成进度',
						type: 'line',
						itemStyle: {
                normal: {
                    lineStyle: {
                      width:1
                    }
                }
            },
						smooth: true,
						data: [],
				},
				{
						name: '近90天复购客户数',
						type: 'line',
						itemStyle: {
                normal: {
                    lineStyle: {
                      width:1
                    }
                }
            },
						smooth: true,
						data: [],
				},
				{
						name: '近90天成交客户数',
						type: 'line',
						itemStyle: {
                normal: {
                    lineStyle: {
                      width:1
                    }
                }
            },
						smooth: true,
						data: [],   
				},
				{
						name: '近90天复购率',
						type: 'line',
						itemStyle: {
                normal: {
                    lineStyle: {
                      width:1
                    }
                }
            },
						smooth: true,
						data: [],
				},
				{
						name: '复购目标完成进度',
						type: 'line',
						itemStyle: {
                normal: {
                    lineStyle: {
                      width:1
                    }
                }
            },
						smooth: true,
						data: [],
				},
				{
						name: '流失客户数',
						type: 'line',
						itemStyle: {
                normal: {
                    lineStyle: {
                      width:1
                    }
                }
            },
						smooth: true,
						data: [],
				},
				{
						name: '历史成交客户数',
						type: 'line',
						itemStyle: {
                normal: {
                    lineStyle: {
                      width:1
                    }
                }
            },
						smooth: true,
						data: [],   
				},
				{
						name: '流失客户占比',
						type: 'line',
						itemStyle: {
                normal: {
                    lineStyle: {
                      width:1
                    }
                }
            },
						smooth: true,
						data: [],
				},
				{
						name: '流失目标完成进度',
						type: 'line',
						itemStyle: {
                normal: {
                    lineStyle: {
                      width:1
                    }
                }
            },
						smooth: true,
						data: [],
				},
		],
		xTitle:[],
		timeCycle: {
			disabledDate: (date) => {
				var time = date.getFullYear();
				var thisDay= new Date(Date.now()).getFullYear()
				var isDisabled = false;
					isDisabled = time < thisDay - 2 || time > thisDay ;
				return isDisabled;
			}
		},
	}
},
computed: {

},
created() {
},
watch: {

},
mounted() {
	this.getData(this.yearValue)
	this.buriedPoint(1, "历史数据",  '行业专区', "行业运营策略")
},
methods: {
		// 获取数据
		getData(year){
			this.tableLoading = true
			historyData(year).then((res) => {
				this.tableLoading = false
				if(res.code === 1){
					this.tableData = res.data
					this.setListData()
				}
      });
		},
		//整理图表数据
		setListData(){
			let arr = this.tableData.reverse()
			if(arr.length == 0){
				this.listChartsData.forEach(item=>{
					item.data=[]
				})
			}else{
			this.xTitle = []
			this.listChartsData.forEach(item=>{
				item.data=[]
			})
			arr.forEach(item=>{
				this.listChartsData[0].data.push(item.newMemberBuyNum)
				this.listChartsData[1].data.push(item.newMemberNum)
				this.listChartsData[2].data.push(item.newMemberFirstBuyRate)
				this.listChartsData[3].data.push(item.firstBuySchedule)

				this.listChartsData[4].data.push(item.purchasedMemberNum)
				this.listChartsData[5].data.push(item.buyerNum)
				this.listChartsData[6].data.push(item.purchasedMemberBuyRate)
				this.listChartsData[7].data.push(item.oldSchedule)

				this.listChartsData[8].data.push(item.purchasedMember90Num)
				this.listChartsData[9].data.push(item.buyer90Num)
				this.listChartsData[10].data.push(item.purchased90Rate)
				this.listChartsData[11].data.push(item.purSchedule)

				this.listChartsData[12].data.push(item.lossNum)
				this.listChartsData[13].data.push(item.buyerNum)
				this.listChartsData[14].data.push(item.lossRate)
				this.listChartsData[15].data.push(item.lossSchedule)

				this.xTitle.push(item.month+'月')
			})
			// arr.map(item=>item.month)
			}
			console.log("this.xTitle--",this.xTitle,this.tableData)
			this.drawChart()
		},
		//年份更改
		getYearData(e){
			this.getData(e)
			// this.formData={
			// 	type: ['新会员首购率','已购会员占比','近90天复购率','流失客户占比'],
			// }
			// this.echartsData={
			// 	legendDatas:['新会员首购率','已购会员占比','近90天复购率','流失客户占比'],
			// }
		},
		//画图
		drawChart() {
      this.myCharts = echarts.init(document.getElementById("line-chart"));
      this.setOptions();
    },
		//统计图配置项
    setOptions() {
			var that = this
      that.options = {

						tooltip: {
							trigger: 'axis',
							extraCssText:'box-shadow:0px 0px 30px 0px rgba(100, 97, 231, 0.15)',
							borderRadius: 4,
							borderWidth: 1,
							borderColor:'#FFFFFF',
							backgroundColor: '#FFFFFF',

							textStyle:{
									fontSize:16,
									color:'#666666'
              },

							axisPointer: {
							// 坐标轴指示器，坐标轴触发有效
								type: "line" ,// 默认为直线，可选为：'line' | 'shadow'
								lineStyle:{
									color: '#6461E7',
									width: 1,
									type: 'dashed'
								}
							},
							formatter:function(params) {
								console.log("params",params)
								var str = // 字符串形式的html标签会被echarts转换渲染成数据，这个res主要是画的tooltip里的上部分的标题部分
								"<div style='margin:8px 15px 5px 15px ;width:100%;color:#999999;font-size:14px'><p>" + that.yearValue + '年'+
								params[0].name +
								"</p></div>";
								// var str = params[0].name + '<br>'
								for(let item of params) {
									if(item.seriesName=='新会员首购率' || item.seriesName=='已购会员占比' 
									|| item.seriesName=='近90天复购率' || item.seriesName=='流失客户占比'
									|| item.seriesName=='首购目标完成进度' || item.seriesName=='招募目标完成进度'
									|| item.seriesName=='复购目标完成进度' || item.seriesName=='流失目标完成进度'){
										str += "<div style='margin:8px 15px 8px 15px'>" + item.marker +'&nbsp'+item.seriesName + ' : ' +'&nbsp'+ item.value + '%<br></div>'
									}else{
										str += "<div style='margin:8px 15px 8px 15px'>" +  item.marker +'&nbsp'+ item.seriesName + ' : ' +'&nbsp'+ item.value + '<br></div>'
									}
								}
								return str;
							},
						},
						legend: {
							bottom:'0',
						},
						grid: {
							left: '3%',
							right: '4%',
							x:'12%',
							y:'12%',
							x2:'12%',
							y2:'10%',
							containLabel: true
						},
						xAxis: {
							type: 'category',
							boundaryGap: false,
							axisLine: {
								lineStyle: {
										color: '#F6F6F6'
								}
							},
							axisLabel:{
								color:'#999999'
							},
							data:this.xTitle
						},
						yAxis: {
							type: 'value',
							axisLine:{
								show:false
							},
							splitLine: {
									lineStyle: {
											color: '#F6F6F6',
											//type:'dashed'虚线
									}
							}
						},
						// series: [
						// 	{
						// 		name: '新会员首购率',
						// 		type: 'line',
						// 		smooth: true,
						// 		stack: 'Total',
						// 		data: this.listChartsData[2].data
						// 	},
						// 	{
						// 		name: '已购会员占比',
						// 		type: 'line',
						// 		smooth: true,
						// 		stack: 'Total',
						// 		data: this.listChartsData[6].data
						// 	},
						// 	{
						// 		name: '近90天复购率',
						// 		type: 'line',
						// 		smooth: true,
						// 		stack: 'Total',
						// 		data: this.listChartsData[10].data
						// 	},
						// 	{
						// 		name: '流失客户占比',
						// 		type: 'line',
						// 		stack: 'Total',
						// 		data: this.listChartsData[14].data
						// 	}
						// ]
						series:[],
			};
			this.changewd(this.echartsData.legendDatas)
      // that.myCharts.setOption(that.options);
    },
		//勾选数据
		handleCheckedForm(value){
			if(value.length > 4){
				this.$message.warning('最多只能勾选4项')
				return;
			}
			this.echartsData.legendDatas=value
			this.changewd(value)
		},
		changewd(e){
				const listData = this.listChartsData
				const data=[];  //循环的series数据
				const legendList=[]; //循环的legend数据
				//循环对比e选中的数据名字和模拟数据中的name相同时push到数组中
				for (let i = 0; i < e.length; i++) {
					for (let j = 0; j < listData.length; j++) {
						// 相同条件名字的push到数组中
						if (e[i] == listData[j].name) {
							data.push(listData[j]);
							legendList.push(listData[j].name)
						}
					}
				}
				//赋值
				this.options.series = data
				this.options.legend.data = legendList
				console.log("this.options.series",this.options.series )
				//图表刷新变化
				this.myCharts.setOption(this.options,true);
		} 
	}
}
</script>
<style lang='scss'>
		.el-date-picker__header-label:hover,
		.el-picker-panel__icon-btn:hover,
		.el-year-table td.current:not(.disabled) .cell,
		.el-year-table td .cell:hover,
		.el-year-table td.today .cell{
			color: #6461e7 !important;
		}
</style>
<style lang='scss' scoped>
.cont{
	width: 1200px;
	margin: 0 auto;
}
// /deep/.el-table .el-table__header-wrapper th .cell{
// 	line-height: inherit;
// }
.notableData{
	width: 1200px;
	height: 60px;
	text-align: center;
	line-height: 60px;
	background: #FFFFFFFF;
	position: absolute;
	z-index: 99;
	top: 50px;
	color: #909399;
	font-size: 14px;
}
.historyTable{
	padding: 40px 0;
	.topBlock{
		display: flex;
    align-items: center;
    justify-content: space-between;
		/deep/.el-input__inner{
			padding-left: 30px !important;
		}
		/deep/.el-input__inner:focus,.el-input__inner:hover{
		border-color: #6461e7;
		}
	}
	.tableBlock{
		margin:15px 0;
		position: relative;
		// /deep/.el-table th.el-table__cell > .cell{
    // 	padding-left: 30px;
		// }		
	}
}
.blockTitle{
	font-size: 16px;
	font-weight: bold;
	color: #333333;
	line-height: 19px;
	padding-left: 5px;
	border-left: 4px solid #6461e7;
	border-radius: 2px 2px 2px 2px;
}
.formData{
	border: 1px solid #F0F0F0;
	border-bottom: 0;
	margin: 16px 0 0 0;
	.el-form-item__content{
		margin-left: 0;
    display: flex;
    align-items: center;
	}
	.formItem{
		display: flex;
		align-content: center;
		margin: 0;
		border-bottom: 1px solid #F0F0F0;
	}
	.formLabel{
		padding: 20px 37px;
		background: #F7F7FF;
	}
	.formCheck{
		padding: 0 35px;
		line-height: 72px;
		height: 72px;
		.el-checkbox{
			width: 170px;
		}
	}
	/deep/.el-checkbox__input.is-checked + .el-checkbox__label{
		color: #666666;
	}
	/deep/.el-checkbox__input.is-checked .el-checkbox__inner{
		background: #6461E7;
		border-color: #6461E7;
	}
	/deep/.el-checkbox__inner:hover,/deep/.el-checkbox__input.is-focus .el-checkbox__inner{
		border-color: #6461E7;
	}
}
.formNum{
	font-size: 14px;
	font-weight: 400;
	color: #999999;
	margin: 12px 0;
}
.noData{
	text-align: center; 
	position: absolute; 
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
</style>